export default "__VITE_ASSET__16199b35__"